import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';

@Component({
  selector: 'emm-add-component-dialog',
  templateUrl: './add-component-dialog.component.html',
  styleUrl: './add-component-dialog.component.scss'
})
export class AddComponentDialogComponent implements OnInit{

    form: FormGroup;
    allowedComponents = [
        {
            name: 'Lite Ice',
            tag: 'ICE_LITE',
        },
        {
            name: 'Extra Ice',
            tag: 'ICE_EXTRA',
        },
        {
            name: 'No Ice',
            tag: 'ICE_NONE',
        }
    ];
    selectedComponents = [];
    existingComponents: string[] = [];
    readonly separatorKeysCodes: number[] = [ENTER, COMMA];

    @ViewChild('optionInput') optionInput!: ElementRef<HTMLInputElement>;

    constructor(
        public dialogRef: MatDialogRef<AddComponentDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { existingComponents?: any[] }
    ) {}

    ngOnInit() {
        // TODO: Add logic that only allows relevant components to be added.
        //  This should be based on the class of the item that opened this dialog and we may need an autocomplete
        //  rather than a text field.

        if (this.data?.existingComponents) {
            this.existingComponents = this.data.existingComponents
                .map(c => typeof c === 'string' ? c.trim() : c?.tag)
                .filter(Boolean)
                .map(tag => tag.toUpperCase());
        }

        this.buildForm();
    }

    buildForm() {
        this.form = new FormGroup({
            newComponent: new FormControl('', [Validators.required, this.duplicateComponentValidator()])
        });
    }

    duplicateComponentValidator(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            if (!control.value) {
                return null;
            }

            const inputValue = control.value.trim();
            if (!inputValue) {
                return null;
            }

            const newTags = inputValue
                .split(',')
                .map(tag => tag.trim().toUpperCase())
                .filter(Boolean);

            const duplicates = newTags.filter(tag => this.existingComponents.includes(tag));

            if (duplicates.length > 0) {
                return {
                    duplicateComponent: {
                        value: duplicates.join(', ')
                    }
                };
            }

            return null;
        };
    }

    close(): void {
        this.dialogRef.close();
    }

    save() {
        if (this.form.valid) {
            this.dialogRef.close(this.form.controls['newComponent'].value);
            // this.dialogRef.close(this.selectedComponents);
        }
    }

    onEnterKey(event: KeyboardEvent) {
        event.preventDefault();

        if (this.form.valid && !this.form.pristine) {
            this.save();
        }
    }

    add(event: MatChipInputEvent): void {
        const input = event.input;
        const value = (event.value || '').trim();

        if (value) {
            if (!this.selectedComponents.includes(value)) {
                this.selectedComponents.push(value);
            }
        }

        if (input) {
            input.value = '';
        }
        this.form.controls['newComponent'].setValue(null);
    }

    remove(option: string): void {
        const index = this.selectedComponents.indexOf(option);
        if (index >= 0) {
            this.selectedComponents.splice(index, 1);
        }
    }

    selected(event: MatAutocompleteSelectedEvent): void {
        const value = event.option.viewValue;
        if (!this.selectedComponents.includes(value)) {
            this.selectedComponents.push(value);
        }
        this.optionInput.nativeElement.value = '';
        this.form.controls['newComponent'].setValue(null);
    }
}
